import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DriverService } from '@core/services/driver.service';
import { CouponResponse } from '@core/models/promo-code.modal';
import { ToastService } from 'src/app/shared/services/toast.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-promo-come-modal',
  templateUrl: './promo-come-modal.component.html',
  styleUrls: ['./promo-come-modal.component.scss']
})
export class PromoComeModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  checkCouponValidityForm: FormGroup;
  couponValidity: CouponResponse;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly driverService: DriverService,
    private readonly formBuilder: FormBuilder,
    private readonly toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.checkCouponValidityForm = this.formBuilder.group({
      couponCode: ['', Validators.required]
    });
  }

  cancelDialog(): void {
    this.ref.close();
  }

  CheckCouponValidity(): void {
    if (this.checkCouponValidityForm.valid) {
      this.driverService.CheckCouponValidity(this.checkCouponValidityForm.value.couponCode)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: (res: CouponResponse) => {
            this.couponValidity = res;
          },
          error: (err) => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
              this.toastService.showToastMessage('error','Error', err.error['message']);
          }
        });
    }
  }

  confirmDilog() {
    if (this.couponValidity?.offerStatus) {
      this.ref.close(this.couponValidity);
    }
  }

  clearOffer() {
    this.couponValidity = null;
    this.checkCouponValidityForm.get('couponCode').setValue('');
  }
}
